import React, { useEffect } from 'react';

export default function SEO() {
  useEffect(() => {
    // Set page title
    document.title = 'Elite Roofing and Construction LLC - Central Florida Roofing & Exterior Services';
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional roofing and exterior construction services in Central Florida. Fast response, photo documentation, HOA & commercial ready. Roof repair, stucco, painting, and more.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Professional roofing and exterior construction services in Central Florida. Fast response, photo documentation, HOA & commercial ready. Roof repair, stucco, painting, and more.';
      document.head.appendChild(meta);
    }
    
    // Add structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Elite Roofing and Construction LLC",
      "image": "https://janet-chatbot-demo.preview.emergentagent.com/assets/logo.png",
      "@id": "https://elitercfl.com",
      "url": "https://elitercfl.com",
      "telephone": "+14077850642",
      "email": "jeremy@elitercfl.com",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Orlando",
        "addressRegion": "FL",
        "addressCountry": "US"
      },
      "areaServed": [
        {"@type": "City", "name": "Orlando, FL"},
        {"@type": "City", "name": "Kissimmee, FL"},
        {"@type": "City", "name": "Davenport, FL"},
        {"@type": "City", "name": "Winter Garden, FL"},
        {"@type": "City", "name": "Windermere, FL"},
        {"@type": "City", "name": "Lake Nona, FL"},
        {"@type": "City", "name": "Clermont, FL"},
        {"@type": "City", "name": "Sanford, FL"}
      ],
      "sameAs": [
        "https://elitercfl.com"
      ],
      "description": "Professional roofing and exterior construction services in Central Florida. Fast response, documentation-focused, HOA and commercial ready. Specializing in roof repair, stucco, painting, and more."
    });
    document.head.appendChild(script);
  }, []);

  return null;
}
